<template>
  <span>
    <span class="mr-1">{{ label }}</span>
  </span>
</template>

<script>
import KitVersion from '@/models/KitVersion';

export default {
  props: {
    kit: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      statuses: {
        VALIDATED: { badge: 'success' },
        NOT_VALIDATED: { badge: 'info' },
        PERF: { badge: 'danger' },
        default: { badge: 'secondary' }
      }
    };
  },
  computed: {
    label() {
      // manage kit version
      if (this.kit instanceof KitVersion) {
        return this.kit.kit.id ? this.kit.kit.name : this.$t(this.kit.kit.name);
      }

      return this.kit.id ? this.kit.name : this.$t(this.kit.name);
    }
  }
};
</script>